import React from "react";

/**
 * Captura errores de render en el árbol de componentes para evitar
 * la pantalla en blanco (que en una boletería significa venta perdida).
 * Muestra un fallback con opción de reintentar / volver al inicio.
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Log para diagnóstico (visible en la consola del navegador / monitoreo).
        console.error("ErrorBoundary capturó un error:", error, info);
    }

    handleReload = () => {
        this.setState({ hasError: false });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-[#0f0e17] text-white flex items-center justify-center px-4">
                    <div className="max-w-md w-full text-center">
                        <span className="text-brand font-mono font-semibold text-sm uppercase tracking-widest">
                            Algo salió mal
                        </span>
                        <h1 className="text-2xl sm:text-3xl font-bold mt-3 font-display">
                            Tuvimos un problema al cargar esta página
                        </h1>
                        <p className="text-gray-400 mt-3 leading-relaxed">
                            No te preocupes, tu información está a salvo. Intenta recargar
                            la página o vuelve al inicio.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-7">
                            <button onClick={this.handleReload} className="thm-btn">
                                Recargar
                            </button>
                            <a href="/" className="thm-btn">
                                Ir al inicio
                            </a>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
